<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="green">
            <span 
              class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>
  
            <template v-slot:action="{ attrs }">
              <v-btn
                icon
                color="white"
                class="body-1 font-weight-bold text-capitalize"
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
  
          <v-dialog v-model="dialog.freeze"
            @keydown.esc="dialog.freeze = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Freeze Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div 
                          class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in configHeaders" 
                              :key="index"
                              class="px-0"
                              @click="item.freeze = !item.freeze ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.freeze">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.freeze ? 'font-weight-bold' : ''"
                                  :style="item.freeze ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Freeze
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.hide"
            @keydown.esc="dialog.hide = false"
            :fullscreen="dialog.fullscreen"
            width="400"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pt-3 pb-0 text-right popup-header">
                Hide Kolom
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.hide = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mt-3 mb-2"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-text 
                class="py-0">
                <v-form>
                  <v-row>
                    <v-col>
                      <div>
                        <div class="mb-2">
                          Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                        </div>
  
                        <v-list-item-group
                          multiple>
                          <v-list flat>
                            <v-list-item 
                              v-for="(item, index) in headers" 
                              :key="index"
                              class="px-0"
                              @click="item.hide = !item.hide ? true : false">
                              <v-list-item-action 
                                class="mr-4">
                                <v-checkbox
                                  :color="set_color"
                                  :input-value="item.hide">
                                </v-checkbox>
                              </v-list-item-action>
  
                              <v-list-item-content>
                                <div
                                  :class="item.hide ? 'font-weight-bold' : ''"
                                  :style="item.hide ? `color: ${set_color};` : ''">
                                  {{ item.text }}
                                </div>
                              </v-list-item-content>
                            </v-list-item>  
                          </v-list>
                        </v-list-item-group>
                      </div>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
  
              <v-divider 
                class="mb-3 mt-0"
                style="border-top: 2px dashed #EBEBEB;"/>
  
              <v-card-actions
                class="mb-2">
                <v-spacer/>
  
                <v-btn
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 10px;"
                  class="body-2 font-weight-bold text-capitalize white--text"
                  @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                  <v-icon small class="mr-1">mdi-check-bold</v-icon>
                  Hide
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                <div
                  class="title font-weight-bold">
                  Pilih Gambar
                </div>
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false; message.error = ''; image.src = '';"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
  
                <div style="width: 100%; height: 400px;" v-if="image.src === ''">
                  <!-- <folderImage
                    v-model="upload.images">
                    <div 
                      slot="activator"> -->
                      <v-card 
                        flat
                        width="100%"
                        height="400"
                        class="d-flex align-center justify-center cursor-pointer"
                        style="border-radius: 15px;
                              border: 2px solid #EBEBEB; 
                              border-style: dashed;">
                        <v-avatar
                          v-ripple
                          tile 
                          width="250"
                          height="200">
                          <v-icon
                            size="50"
                            color="#B9B9B9">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-avatar>
                      </v-card>
                    <!-- </div>
                  </folderImage> -->
                </div>
  
                <div v-if="image.src !== ''">
                  <cropper
                    class="cropper"
                    ref="cropper"
                    style="width: 100%; height: 400px;"
                    :src="image.src"
                    @change="change"
                  ></cropper>
                </div>
  
  
                <!-- <v-btn
                  @click="cropImage()"
                  color="primary"
                  class="mt-6"
                  style="border-radius: 10px;">
                  <v-icon left>mdi-crop</v-icon>
                  Crop Gambar
                </v-btn> -->
  
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <div style="width: 150px;">
                  <folderImage
                    v-model="upload.images">
                    <div 
                      slot="activator">
                      <v-btn
                        :disabled="process.images"
                        width="150"
                        elevation="0"
                        color="indigo"
                        rounded
                        class="body-2 font-weight-bold text-capitalize white--text">
                        Ubah Gambar
                      </v-btn>
                    </div>
                  </folderImage>
                </div>
  
                <v-btn
                  @click="cropImage()"
                  :loading="process.images"
                  :disabled="process.images"
                  width="120"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text ml-2">
                  Pilih Gambar
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; message.error = ''; image.src = ''; dialog.fullscreen = false;"
                  :disabled="process.images"
                  width="120"
                  outlined
                  elevation="0"
                  color="red"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <section>
            <v-card 
              flat
              class="ma-3 box-shadow"
              style="border-radius: 10px;">
              <v-card-text 
                class="py-4">
                <v-card
                  flat
                  class="mt-0 mb-5"
                  to="/berita"
                  color="transparent">
                  <div
                    class="d-flex align-center px-0">
                    <div
                      class="d-flex align-center">
                      <v-avatar
                        tile
                        size="22">
                        <v-img
                          contain
                          alt="kominfoklaten"  
                          :src="require('@/assets/icon/back_arrow.png')">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
  
                      <span
                        class="fs-18 black--text ml-2"
                        style="font-weight: 600;">
                        Ubah Berita
                      </span>
                    </div>
  
                    <v-spacer />
                  </div>
                </v-card>
  
                <div v-if="!process.load">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <ValidationProvider
                        name="Judul" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2 mt-5">
                          <span class="red--text">*</span>
                          Judul
                        </div>
    
                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          autofocus
    
                          :color="set_color"
                          placeholder="Contoh. Berita A"
    
                          hide-details
    
                          v-model="form.title"
                          :success="form.title !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
    
                            <div v-if="form.title !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
    
                      <ValidationProvider
                        name="Unit" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Kategori Berita
                        </div>
    
                        <v-select
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
    
                          :color="set_color"
                          placeholder="Contoh. Berita"
    
                          hide-details
                          
                          :items="category"
                          item-value="id"
                          item-text="title"
                          :item-color="set_color"
    
                          v-model="form.category_id"
                          :success="form.category_id !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-6"
                          style="border-radius: 10px; width: 50%;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
    
                            <div v-if="form.category_id !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-select>
                      </ValidationProvider>
    
                      
  
                    <div class="body-2 mb-2 mt-6">
                      <!-- <span class="red--text">*</span> -->
                      Gambar Cover
                    </div>
  
                    <div style="width: 250px; height: 200px;" v-if="form.image_url_cover === ''">
                      <folderImage
                        v-model="upload.cover">
                        <div 
                          slot="activator">
                          <v-card 
                            flat
                            width="250"
                            height="200"
                            class="d-flex align-center justify-center cursor-pointer"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar v-if="!process.cover"
                              v-ripple
                              tile 
                              width="250"
                              height="200">
                              <v-icon
                                size="50"
                                color="#B9B9B9">
                                mdi-cloud-upload-outline
                              </v-icon>
                            </v-avatar>
  
                            <v-progress-circular v-else
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </v-card>
                        </div>
                      </folderImage>
                    </div>
  
                    <!-- <div style="width: 250px; height: 200px;"  v-if="form.image_url_cover === ''">
                      <folderImage v-if="form.image_url_cover === ''"
                        v-model="upload.images">
                        <div 
                          slot="activator">
                          <v-card 
                            flat
                            width="250"
                            height="200"
                            @click="image.src = ''; message.error = '';"
                            class="d-flex align-center justify-center cursor-pointer"
                            style="border-radius: 15px;
                                  border: 2px solid #EBEBEB; 
                                  border-style: dashed;">
                            <v-avatar 
                              v-ripple
                              tile 
                              width="250"
                              height="200">
                              <v-icon
                                size="50"
                                color="#B9B9B9">
                                mdi-cloud-upload-outline
                              </v-icon>
                            </v-avatar>
                          </v-card>
                        </div>
                      </folderImage>
                    </div> -->
  
  
                    <v-card v-if="form.image_url_cover !== ''"
                      flat
                      width="250"
                      height="200"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #EBEBEB; 
                            border-style: dashed;">
                      <v-avatar
                        v-ripple
                        tile 
                        size="200"
                        style="border-radius: 15px;">
                        <v-img 
                          contain
                          width="100%"
                          height="100%"
                          alt="diskominfo" 
                          :src="cdnFallback['image_url_cover'] ? getCdnLegacyDisplayUrl(form.image_url_cover) : getCdnDisplayUrl(form.image_url_cover)"
                        @error="cdnFallback = { ...cdnFallback, 'image_url_cover': true }"
                          class="ma-auto"
                          style="border-radius: 15px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
  
                      <v-icon 
                        @click="form.image_url_cover = ''"
                        color="red"
                        class="cursor-pointer"
                        style="position: absolute; top: -10px; right: -10px;">
                        mdi-close-circle
                      </v-icon>
                    </v-card>
                      
                      <!-- <img 
                        width="200"
                        height="200"
                        :src="test_img"/> -->
  
                    <div class="body-2 mb-2 mt-6">
                      <span class="red--text">*</span>
                      Gambar Berita
                    </div>
  
                    <v-radio-group
                      v-model="form.image_type"
                      column
                    >
                      <v-radio
                        label="Single Gambar"
                        value="single"
                        :color="set_color"
                      ></v-radio>
                      <v-radio
                        label="Multiple Gambar"
                        value="multiple"
                        :color="set_color"
                      ></v-radio>
                    </v-radio-group>
  
                    <div v-if="form.image_type === 'single'">
                      
                      <div style="width: 250px; height: 200px;" v-if="form.image_url === ''">
                        <folderImage v-if="form.image_url === ''"
                            v-model="upload.folder">
                            <div 
                              slot="activator">
                              <v-card 
                                flat
                                width="250"
                                height="200"
                                class="d-flex align-center justify-center cursor-pointer"
                                style="border-radius: 15px;
                                      border: 2px solid #EBEBEB; 
                                      border-style: dashed;">
                                <v-avatar v-if="!process.file"
                                  v-ripple
                                  tile 
                                  width="100%"
                                  height="200">
                                  <v-icon
                                    size="50"
                                    color="#B9B9B9">
                                    mdi-cloud-upload-outline
                                  </v-icon>
                                </v-avatar>
      
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </folderImage>
                      </div>
                      <v-card v-if="form.image_url !== ''"
                        flat
                        width="250"
                        height="200"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #EBEBEB; 
                              border-style: dashed;">
                        <v-avatar
                          v-ripple
                          tile 
                          width="100%"
                          height="200"
                          style="border-radius: 15px;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="diskominfo" 
                            :src="cdnFallback['image_url'] ? getCdnLegacyDisplayUrl(form.image_url) : getCdnDisplayUrl(form.image_url)"
                        @error="cdnFallback = { ...cdnFallback, 'image_url': true }"
                            class="ma-auto"
                            style="border-radius: 15px;">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
        
                        <v-icon 
                          @click="form.image_url = ''"
                          color="red"
                          class="cursor-pointer"
                          style="position: absolute; top: -10px; right: -10px;">
                          mdi-close-circle
                        </v-icon>
                      </v-card>
                    </div>
  
                    <div v-if="form.image_type === 'multiple'">
                      
  
                      <v-row>
                        <v-col 
                          v-for="(item, index) in form.image_url_json"
                          :key="index"
                          cols="3" 
                          md="3">
                          <v-card 
                            flat
                            width="100%"
                            height="200"
                            class="d-flex align-center justify-center"
                            style="border-radius: 15px;
                                  border: 2px solid #eaeaea; 
                                  border-style: dashed;
                                  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                            <v-img 
                              alt="locafe" 
                              width="100%"
                              height="196"
                              :src="item"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
  
                              <div 
                                @click="form.image_url_json.splice(index, 1)"
                                class="cursor-pointer"
                                style="position: absolute; top: 5px; right: 5px;">
                                <v-icon size="24" color="red">mdi-close-circle</v-icon>
                              </div>
                            </v-img>
                          </v-card>
                        </v-col>
  
                        <v-col
                          cols="3" 
                          md="3">
                          <folderImage 
                            v-model="upload.multi">
                            <div 
                              slot="activator" 
                              class="cursor-pointer">
                              <v-card 
                                flat
                                width="100%"
                                height="200"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;">
                                <v-icon v-if="!process.file"
                                  size="60" 
                                  color="grey">
                                  mdi-cloud-upload-outline
                                </v-icon>
  
                                <v-progress-circular v-else
                                  indeterminate
                                  :color="set_color">
                                </v-progress-circular>
                              </v-card>
                            </div>
                          </folderImage>
                        </v-col>
                      </v-row>
                      
                    </div>
  
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Tanggal Publish
                          </div>
        
                          <v-menu
                            v-model="date.start"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                            >
                            <template v-slot:activator="{ on, attrs }">
                              <ValidationProvider
                                name="Tanggal Mulai" 
                                rules="required" 
                                v-slot="{ errors, valid }">
                                <v-text-field
                                  v-model="form.publish_datetime"
                                  placeholder="Pilih Tanggal Mulai"
                                  hide-details
                                  :color="set_color"
                                  readonly
                                  filled
                                  rounded
                                  dense
                                  required
                                  v-bind="attrs"
                                  v-on="on"
                                  :success="form.publish_datetime !== '' && valid"
                                  :error-messages="errors"
                                  class="mb-6"
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>
        
                                    <div v-if="form.publish_datetime !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                            </ValidationProvider>
                            </template>
                            <v-date-picker
                              v-model="form.publish_datetime"
                              :color="set_color"
                              @input="date.start = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Waktu Publish
                          </div>
                          <ValidationProvider 
                            :name="`Waktu`" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <v-text-field
                              v-model="form.time"
                              
                              v-on:keyup.enter="save()"
                              
                              hide-details
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Waktu"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;"
                              type="time"
                              locale="id"
                              >
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.time !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
    
                      <div class="body-2 mb-2">
                        Status
                      </div>
    
                      <v-select
                        v-on:keydown.enter.prevent="save()"
                        
                        filled
                        rounded
                        dense
                        
    
                        :color="set_color"
                        placeholder="Contoh. Draft"
    
                        hide-details
                        
                        :items="status"
                        :item-color="set_color"
    
                        v-model="form.status"
                        class="mb-6"
                        style="border-radius: 10px;">
                      </v-select>
    
                      <v-checkbox
                        v-model="form.is_highlight"
                        label="Berita Pilihan"
                        value="1"
                      ></v-checkbox>
    
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Deskripsi
                      </div>
    
                      <quill-editor 
                        ref="myTextEditor"
                        :options="{
                          placeholder: 'Contoh. Tuliskan deskripsi disini . . .',
                          modules: quill_modules
                        }"
                        v-model="form.content">
                      </quill-editor>
                      
                      <!-- <ValidationProvider 
                        name="Deskripsi" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Deskripsi
                        </div>
        
                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
        
                          :color="set_color"
                          placeholder="Contoh. Tuliskan deskripsi disini . . ."
        
                          hide-details
        
                          v-model="form.desc"
                          :success="form.desc !== '' && valid"
                          :error-messages="errors"
                          required
                          class="mb-2"
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.desc !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-textarea>
                      </ValidationProvider> -->
        
                      <!-- <div>
                        <div>
                          <div
                            class="body-2 mt-5">
                            <span class="red--text">*</span>
                            Gambar
                          </div>
                        </div>
    
                        <v-row>
                          <v-col 
                            v-for="(item, index) in form.image_url"
                            :key="index"
                            cols="6" 
                            md="6">
                            <v-card 
                              flat
                              width="100%"
                              height="200"
                              class="d-flex align-center justify-center"
                              style="border-radius: 15px;
                                    border: 2px solid #eaeaea; 
                                    border-style: dashed;
                                    box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                              <v-img 
                                alt="locafe" 
                                width="100%"
                                height="196"
                                :src="item"
                                class="ma-auto">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
    
                                <div 
                                  @click="form.image_url.splice(index, 1)"
                                  class="cursor-pointer"
                                  style="position: absolute; top: 5px; right: 5px;">
                                  <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                </div>
                              </v-img>
                            </v-card>
                          </v-col>
    
                          <v-col
                            cols="6" 
                            md="6">
                            <multiple 
                              v-model="upload.folder">
                              <div 
                                slot="activator" 
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  width="100%"
                                  height="200"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <v-icon v-if="!process.file"
                                    size="60" 
                                    color="grey">
                                    mdi-cloud-upload-outline
                                  </v-icon>
    
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-card>
                              </div>
                            </multiple>
                          </v-col>
                        </v-row>
                      </div> -->
                    </v-form>
                  </ValidationObserver>
                </div>
  
                <v-card-text
                  v-if="process.load" 
                  class="pb-0 my-4" 
                  style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-4 title">
                      Mohon Tunggu . . .
                    </div>
  
                    <v-progress-linear
                      :color="set_color"
                      indeterminate
                      rounded
                      height="10">
                    </v-progress-linear>
                  </div>
                </v-card-text>
  
  
                <div v-if="message.error.length > 0"
                  class="text-center mt-6">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
  
                <v-card-actions
                  class="pa-4">
                  <v-spacer/>
  
                  <v-btn
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form || process.load"
                    width="120"
                    elevation="0"
                    color="green"
                    style="border-radius: 6px;"
                    class="font-weight-bold text-capitalize white--text">
                    Simpan
                  </v-btn>
  
                  <v-btn
                    to="/berita"
                    :disabled="process.form || process.load"
                    width="120"
                    elevation="0"
                    color="red"
                    style="border-radius: 6px;"
                    class="font-weight-bold text-capitalize white--text">
                    Batal
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
  import { getCdnDisplayUrl } from '@/utils/cdn'
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          cdnFallback: {}, // key -> true kalau proxy CDN gagal load, dipakai getCdnLegacyDisplayUrl
          checkbox: false,
  
          status: [
            'draft', 'publish'
          ],
  
          dialog: {
            fullscreen: false,
            snackbar: false,
            freeze: false,
            hide: false,
  
            form: false,
            delete: false
          },
          
          search: '',
  
          img_to_galery: [],
  
          date: {
            start: false,
            end: false
          },
  
          filter: {
            category: []
          },
  
          selected: {
            row: [],
            freeze: [],
            delete: [],
            category_id: '',
            status: false
          },
  
          upload: {
            folder: null,
            multi: null,
            cover: null,
            images: null
          },
  
          category: [],
  
          quill_modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              ['blockquote', 'code-block'],
  
              [{ 'header': 1 }, { 'header': 2 }],               // custom button values
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
              [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
              [{ 'direction': 'rtl' }],                         // text direction
  
              [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  
              [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
              // [{ 'font': [] }],
              [{ 'align': [] }],
  
              ['clean'],
  
              ['link', 'video', 'formula']
            ],
          },
  
          options: {},
          headers: [],
          list: [],
          pagination: {},
  
          lastIndex: 0,
          limit: 20,
  
          form: {
            id: '',
            title: '',
            content: '',
            slug: '',
            meta_json: {},
            image_url: "",
            category_par_id: "1",
            category_id: '',
            publish_datetime: '',
            is_active: 1,
            image_url_cover: '',
            image_type: 'single',
            image_url_json: [],
            status: 'draft',
            is_highlight: "0",
            time: ''
          },
          file_image: [],
  
          process: {
            load: false,
  
            form: false,
  
            delete: false,
  
            cover: false
          },
          image: {
            src: 'https://images.pexels.com/photos/226746/pexels-photo-226746.jpeg',
            type: "image/jpg",
            name: "image.jpg"
          },
          test_img: '',
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
        folderImage: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        multiple: () => import(/* webpackPrefetch: true */ '@/components/upload/multiple.vue')
      },
      watch: {
        'upload.cover': {
          handler: function () {
            if (this.upload.cover) {
              this.process.cover = this.upload.cover.process
  
              if (!this.process.cover) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url_cover = this.upload.cover.fullpath
                
              }
            }
          },
          deep: true
        },
  
        'upload.images': {
          handler: function () {
            if (this.upload.images) {
              this.image.src = this.upload.images.fullpath
              this.image.type = this.upload.images.filemime
              this.file_image = this.upload.images.file,
              this.image.name = this.upload.images.filename
              if (this.dialog.form) {
                  
              } else {
                this.dialog.form = true
              }
            }
          },
          deep: true
        },
  
        'upload.folder': {
          handler: function () {
            if (this.upload.folder) {
              this.process.file = this.upload.folder.process
  
              if (!this.process.file) {
                // CALLBACK FROM UPLOAD IMAGE
                console.log(this.upload.folder.fullpath)
                
                this.form.image_url = this.upload.folder.fullpath
              }
            }
          },
          deep: true
        },
  
        'upload.multi': {
          handler: function () {
            if (this.upload.multi) {
              this.process.file = this.upload.multi.process
  
              if (!this.process.file) {
                // CALLBACK FROM UPLOAD IMAGE

                this.form.image_url_json.push(this.upload.multi.fullpath)

                this.upload.multi = null
              }
            }
          },
          deep: true
        }
      },
      computed: {
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        user () {
          return this.$store.state.user
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
  
        configHeaders () {
          return this.headers.filter(header => !header.hide)  
        }
      },
      mounted () {
        this.fetch()
      },
      destroyed() {
        // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
      },
      methods: {
        change({coordinates, canvas, image}) {
          console.log(coordinates, canvas, image)
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[arr.length - 1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
        },
        cropImage() {
          this.test_img = ''
          this.process.images = true
          const result = this.$refs.cropper.getResult();
          this.test_img = result.canvas.toDataURL(
            this.image.type
          )
  
          this.file_image = this.dataURLtoFile(this.test_img, this.image.name);
          // console.log(file)
  
          if (this.test_img !== '') {
            this.saveImage()
          }
        },
        uploadImage(event) {
          /// Reference to the DOM input element
          const { files } = event.target;
          // Ensure that you have a file before attempting to read it
          if (files && files[0]) {
            // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
            if (this.image.src) {
              URL.revokeObjectURL(this.image.src);
            }
            // 2. Create the blob link to the file to optimize performance:
            const blob = URL.createObjectURL(files[0]);
  
            // 3. Update the image. The type will be derived from the extension and it can lead to an incorrect result:
            this.image = {
              src: blob,
              type: files[0].type,
            };
          }
        },
        rowFormat (format, value) {
          let data = value
  
          if (format === 'number') {
            if (isNaN(value)) return 'Not a Number'
            let price = ''
  
            const reverseNumber = value
              .toString()
              .split('')
              .reverse()
              .join('')
            const arrReverseNumber = [...Array(reverseNumber.length).keys()]
  
            arrReverseNumber.map(index => {
              if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
            })
  
            return `Rp ${
              price.split('', price.length - 1)
              .reverse()
              .join('')
            }`
          } else if (format === 'array') {
            let arr = []
  
            for (let i = 0; i < value.length; i++) {
              arr.push(value[i].label)
            }
  
            data = arr.join(', ')
          } else if (format === 'date') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
          } else if (format === 'time') {
            data = value.length > 0 ? moment(value).format('HH:mm') : '-'
          } else if (format === 'datetime') {
            data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
          } else if (format === 'object') {
            data = value.createdby.name
          } else if (format === 'regex') {
            let regex = /(<([^>]+)>)/ig
  
            data = value.replace(regex, '')
          } else if (format === 'underscore') {
            let regex = /_/g
  
            data = value.replace(regex, ' ')
          } else if (format === 'on_off') {
            data = value ? 'Online' : 'Offline'
          } else if (format === 'g_m') {
            data = value ? 'Mandiri' : 'Group'
          } else if (format === 'v_a') {
            data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
          } else if (format === 'y_n') {
            data = parseInt(value) ? 'Ya' : 'Tidak'
          } else if (format === 'percent') {
            data = parseInt(value) + '%'
          } else if (format === 'action') {
            data = value
          } else if (format === 'bool') {
            data = value
          } else if (format === 'status') {
            data = value
          } else if (format === 'link') {
            data = value
          }  else {
            data = value ? 'Aktif' : 'Tidak Aktif'
          }
  
          return data
        },
        rowClick (item, row) {
          row.select(!row.isSelected ? true : false)
        },
        doubleClick (event, {item}) {
          // NO ACTION
        },
        handleToggleAll (event) {
          if (!event.value) this.selected.row = []
        },
  
        async fetchCategory () {
          this.process.load = true
  
          let params = {
            limit: 1000000
          }
  
          await get(`admin/news_category/data`, { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.category = res.results.data
              this.filter.category = []
              this.filter.category = [ 
                {
                  title : 'Semua',
                  id: ""
                }
              ]
              for (let i in res.results.data) {
                this.filter.category.push({
                  title : res.results.data[i].title,
                  id: res.results.data[i].id
                })
              }
            }
            this.process.load = false
          })
        },
  
        async fetch () {
          this.process.load = true
  
          let params = {
            id: this.$route.params.id,
          }
          // admin/services/data
  
          await get(`admin/news/detail`, { params })
          .then(response => {
            let res = response.data
  
            this.process.load = false
              
            if (res.status === 200) {
              this.form = {
                id: res.results.data.id,
                category_par_id: res.results.data.category_par_id,
                title: res.results.data.title,
                slug: res.results.data.slug,
                content: res.results.data.content,
                meta_json: res.results.data.meta_json,
                image_url: res.results.data.image_url,
                category_id: res.results.data.category_id,
                publish_datetime: moment(res.results.data.publish_datetime).format('YYYY-MM-DD'),
                is_active: res.results.data.is_active === true? 1 : 0,
                image_url_cover: res.results.data.image_url_cover,
                image_type: res.results.data.image_type,
                image_url_json: res.results.data.image_url_json === '' ? [] : JSON.parse(res.results.data.image_url_json),
                status: res.results.data.status,
                is_highlight: res.results.data.is_highlight,
                time: moment(res.results.data.publish_datetime).format('HH:mm')
              }
              this.fetchCategory()
            }
          })
        },
  
        addFreezes () {
          this.removeFreezes()
  
          this.selected.freeze = []
  
          for (let i = 0; i < this.configHeaders.length; i++) {
            if (this.configHeaders[i].freeze) {
              // ADD TO SELECTOR
              this.selected.freeze.push({
                child: i + (this.checkbox ? 2 : 1),
                width: this.configHeaders[i].width.split('px')[0]
              })
  
              // LOOP STYLESHEET
              for (let f = 0; f < this.selected.freeze.length; f++) {
                let style = document.createElement('style'),
                    width = 0
  
                if (this.checkbox) {
                  width = f < 1 ? '65' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
                } else {
                  width = f < 1 ? '0' : 
                        f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                        parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
                }
  
                // ADD STYLESHET TO FREEZE
                style.innerHTML = `
                  .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 5;
                    background: #FFFFFF;
                  }
  
                  .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                    left: ${width}px;
                    z-index: 1;
                  }
                `
  
                // ADD TO APPENDCHILD
                document.head.appendChild(style)
              }
            }
          }
        },
        removeFreezes () {
          // LOOP STYLESHEET
          for (let f = 0; f < this.selected.freeze.length; f++) {
            let style = document.createElement('style')
            
            // RESET STYLESHEET TO AUTO
            style.innerHTML = `
              .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
                background: #FFFFFF;
              }
  
              .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                left: auto;
                z-index: auto;
              }
            `
  
            // ADD TO APPENDCHILD
            document.head.appendChild(style)
          }
        },
        addHides () {
          if (this.headers.length < 6) this.getTableToResize()
        },
        getTableToResize () {
          let tables = document.getElementsByTagName('table')
  
          for (let i = 0; i < tables.length; i++) {
            this.resizableGrid(tables[i])
          }
        },
        resizableGrid (table) {
          let row = table.getElementsByTagName('tr')[0],
              cols = row ? row.children : undefined
          
          if (!cols) return
          
          table.style.overflow = 'hidden'
          
          let tableHeight = table.offsetHeight
          
          for (let i = 0; i < cols.length; i++) {
            let div = createDiv(tableHeight)
            cols[i].appendChild(div)
            cols[i].style.position = 'relative'
  
            setListeners(div)
          }
  
          function setListeners (div) {
            let pageX, curCol, nxtCol, curColWidth, nxtColWidth
  
            div.addEventListener('mousedown', e => {
              curCol = e.target.parentElement
              nxtCol = curCol.nextElementSibling
              pageX = e.pageX
              
              let padding = paddingDiff(curCol)
              
              curColWidth = curCol.offsetWidth - padding
  
              if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
            })
  
            div.addEventListener ('mouseover', e => {
              e.target.style.borderRight = '2px solid #e0e0e0'
            })
  
            div.addEventListener ('mouseout', e => {
              e.target.style.borderRight = ''
            })
  
            document.addEventListener ('mousemove', e => {
              if (curCol) {
                let diffX = e.pageX - pageX
            
                if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'
  
                curCol.style.width = (curColWidth + diffX)+'px'
              }
            })
  
            document.addEventListener ('mouseup', () => { 
              curCol = undefined
              nxtCol = undefined
              pageX = undefined
              nxtColWidth = undefined
              curColWidth = undefined
            })
          }
  
          function createDiv (height) {
            let div = document.createElement('div')
  
            div.style.top = 0
            div.style.right = 0
            div.style.width = '1px'
            div.style.position = 'absolute'
            div.style.cursor = 'col-resize'
            div.style.userSelect = 'none'
            div.style.height = height + 'px'
            div.style.background = '#e0e0e0'
  
            return div
          }
  
          function paddingDiff (col) {
            if (getStyleVal(col,'box-sizing') == 'border-box') {
              return 0
            }
            
            let padLeft = getStyleVal(col,'padding-left')
            let padRight = getStyleVal(col,'padding-right')
  
            return (parseInt(padLeft) + parseInt(padRight))
          }
  
          function getStyleVal (elm,css) {
            return (window.getComputedStyle(elm, null).getPropertyValue(css))
          }
        },
  
        // async fetchUnit () {
        //   let params = {
        //     limit: 100000
        //   }
  
        //   await get('admin/unit/data', { params })
        //   .then(response => {
        //     let res = response.data
              
        //     if (res.status === 200) {
        //       this.unit = res.results.data
        //     }
        //   })
        // },
  
        reset (index) {
          if (this.$refs.form) this.$refs.form.reset()
          
          this.form = {
            id: index !== undefined ? this.list[index].id : '',
            category_par_id: index !== undefined ? this.list[index].category_par_id : "1",
            title: index !== undefined ? this.list[index].title : '',
            slug: index !== undefined ? this.list[index].slug : '',
            content: index !== undefined ? this.list[index].content : '',
            meta_json: index !== undefined ? this.list[index].meta_json : {},
            image_url: index !== undefined ? this.list[index].image_url : '',
            category_id: index !== undefined ? this.list[index].category_id : '',
            publish_datetime: index !== undefined ? moment(this.list[index].publish_datetime).format('YYYY-MM-DD') : '',
            is_active: index !== undefined ? this.list[index].is_active === true? 1 : 0 : 1,
            image_url_cover: index !== undefined ? this.list[index].image_url_cover : '',
            image_type: index !== undefined ? this.list[index].image_type : 'single',
            image_url_json: index !== undefined ? this.list[index].image_url_json === '' ? [] : JSON.parse(this.list[index].image_url_json) : [],
            status: index !== undefined ? this.list[index].status : 'draft',
            is_highlight: index !== undefined ? this.list[index].is_highlight : '0',
            time: index !== undefined ? moment(this.list[index].publish_datetime).format('HH:mm') : ''
          }
  
          this.process.form = false
  
          this.message.error = ''
  
          // if (this.dialog.form) this.fetchUnit()
        },
  
        async updateStatus (index) {
          this.message.error = ''
  
          if (this.selected.status === true) {
            this.form = {
              id: index !== undefined ? this.list[index].id : '',
              category_par_id: index !== undefined ? this.list[index].category_par_id : 0,
              title: index !== undefined ? this.list[index].title : '',
              slug: index !== undefined ? this.list[index].slug : '',
              content: index !== undefined ? this.list[index].content : '',
              meta_json: index !== undefined ? this.list[index].meta_json : {},
              image_url: index !== undefined ? this.list[index].image_url : '',
              category_id: index !== undefined ? this.list[index].category_id : '',
              publish_datetime: index !== undefined ? moment(this.list[index].publish_datetime).format('YYYY-MM-DD') : '',
              is_active: index !== undefined ? this.list[index].is_active === true ? 1 : 0 : 1
            }
            this.form.is_active = this.form.is_active === 1 ? 0 : 1
          } 
            this.process.form = true
            this.form.slug = (this.form.title.split(' ').join('-')).toLowerCase()
            this.form.meta_json = JSON.stringify({
              title: this.form.title,
              url: this.form.slug,
              description: String(this.form.content).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'),
              image: this.form.image_url
            })
  
            // SAVE TO REST API
            let url = this.form.id === '' ? 'admin/news/add' : 'admin/news/update'
  
            // SAVE TO REST API
            await post(url, {
              data: this.form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
                this.dialog.form = false
  
                this.dialog.snackbar = true
                this.message.success = res.message
  
                this.dialog.fullscreen = false
  
                this.selected.status = false
  
                this.reset()
  
                this.fetch()
              } else {
                this.message.error = res.message
              }
            })
        },
  
        async saveImage () {
          const isValid = this.image.src !== '' && this.image.src !== null ? true : false
          if (isValid) {
            this.process.images = true
            let formData = new FormData()
                // formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
                // formData.append('secret-key', this.$store.state.user. unit_upload_token)
                formData.append('file', this.file_image)
                formData.append('user_id', this.$store.state.user.id)
            fetch(`https://s1.cdn.klaten.go.id/media/upload/image`, {
              method: 'POST',
              body: formData,
              headers: {
                'secret-key': this.$store.state.user. unit_upload_token
              }
            })
            .then(res => res.json())
            .then(response => {
              // this.process.images = false
  
              // this.$emit('input', {
              //   id: response.data.items[0].filename,
              //   type: response.data.items[0].type,
              //   data: response.data.items[0].data,
              //   process: this.process.file
              // })
  
              this.form.image_url_cover = response.data.items[0].data[0].url
              this.process.images = false
              this.dialog.fullscreen = false
              this.dialog.form = false
            })
          } else {
            this.message.error = 'Gambar tidak boleh kosong'
          }
        },
        
        async save () {
          this.message.error = ''
  
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true
            this.form.slug = (this.form.title.split(' ').join('-')).toLowerCase()
            this.form.image_url = this.form.image_type === 'multiple' ? '' : this.form.image_url
            this.form.is_highlight = this.form.is_highlight === null ? "0" : this.form.is_highlight
            this.form.meta_json = JSON.stringify({
              title: this.form.title,
              url: this.form.slug,
              description: this.form.content.replace( /(<([^>]+)>)/ig, '').replace(/\&nbsp;/g, ''),
              image: this.form.image_url
            })
  
            let forms = {
              id: this.form.id,
              category_par_id: this.form.category_par_id,
              title: this.form.title,
              slug: this.form.slug,
              content: this.form.content,
              meta_json: this.form.meta_json,
              image_url: this.form.image_url,
              category_id: this.form.category_id,
              publish_datetime: `${this.form.publish_datetime} ${this.form.time}`,
              is_active: this.form.is_active,
              image_url_cover: this.form.image_url_cover,
              image_type: this.form.image_type,
              image_url_json: this.form.image_url_json,
              status: this.form.status,
              is_highlight: this.form.is_highlight
            }
            forms.image_url_json = forms.image_type === 'single' ? '' : JSON.stringify(forms.image_url_json)
  
            // SAVE TO REST API
            let url = this.form.id === '' ? 'admin/news/add' : 'admin/news/update'
  
            // SAVE TO REST API
            await post(url, {
              data: forms
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/berita' })
  
                // if (this.form.image_type === 'multiple') {
                //   for(let i = 0; i < this.form.image_url_json.length; i++){
                //     this.saveCategoryGalery(this.form.image_url_json[i], this.form.title)
                //   }
                // } else {
                  // this.saveCategoryGalery(this.form.image_url, this.form.title)
                // }
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
        async saveCategoryGalery (img, desc) {
  
            // SAVE TO REST API
            let url = this.form.id === '' ? 'admin/cat_galery/add' : 'admin/cat_galery/update'
  
            let form = {
              title: desc,
              parent_id: "0",
              is_active: "1"
            }
  
            // SAVE TO REST API
            await post(url, {
              data: form
            })
            .then(response => {
              let res = response.data
              // this.saveGalery(img, desc, res.results.data.id)
  
              if (this.form.image_type === 'multiple') {
                  for(let i = 0; i < this.form.image_url_json.length; i++){
                    this.saveGalery(this.form.image_url_json[i], this.form.title, res.results.data.id)
                  }
                } else {
                  this.saveGalery(this.form.image_url, this.form.title, res.results.data.id)
                }
            })
  
        },
        async saveGalery (img, desc, id) {
  
            // SAVE TO REST API
            let url = this.form.id === '' ? 'admin/galery/add' : 'admin/galery/update'
  
            let form = {
              desc: desc,
              image_url: img,
              cat_galery_id: id
            }
  
            // SAVE TO REST API
            await post(url, {
              data: form
            })
            .then(response => {
              let res = response.data
              this.dialog.form = false
  
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.selected.status = false
              
              this.process.form = false
  
              this.$router.push({ path: '/berita' })
  
              
            })
  
        },
        toDelete (id) {
          this.selected.delete = [id]
  
          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''
  
          this.process.delete = true
  
          await post(`admin/news/delete`, {
            data: {
              id: this.selected.delete[0]
            }
          }).then(response => {
            let res = response.data
  
            this.process.delete = false
  
            if (res.status === 200) {
  
              this.dialog.delete = false
  
              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message
  
              this.dialog.fullscreen = false
  
              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  </script>